import Tone from 'tone';

class LFOFactory {
    constructor() {
        this.lfos = [];
    }

    useLFO() {
        if (this.lfos.length === 0 || !window.explore) {
            return new Tone.LFO(0, -100, 100);
        }

        let lfo = this.lfos.pop();
        return lfo;
    }

    releaseLFO(lfo) {
        if (window.explore) {
            lfo.disconnect();
            this.lfos.push(lfo);
        } else {
            lfo.dispose();
        }
    }
}

export const lfoFactory = new LFOFactory();

